import PageItem from './PageItem';

import './PageItem.scss';

export default PageItem;
